// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gp","advertCardNum":"c-a_gq"};